import client from 'api/client'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { MemberProfile, User } from 'types'
import { reportError } from 'utils/error'
import { useEffect, useState } from 'react'
import { ALMANAC_CORE_WORKSPACE_ID } from 'utils/constants'

interface Data {
  user: User | null
  member: MemberProfile | null
  isLoading: boolean
}

export const useOnboarding = (): Data => {
  const currentWorkspaceId = useCurrentWorkspaceId()
  const [user, setUser] = useState<User | null>(null)
  const [member, setMember] = useState<MemberProfile | null>(null)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true)
      try {
        const authInfo = await client.getAuthInfo()

        if (authInfo.type !== SUCCESS_RESPONSE_TYPE) {
          throw new Error('Unable to fetch auth info')
        }

        const { user } = authInfo.data

        if (!user) {
          throw new Error('User not found')
        }

        if (currentWorkspaceId !== ALMANAC_CORE_WORKSPACE_ID) {
          const member = await client.getMemberProfile(currentWorkspaceId, user.id)

          if (member.type !== SUCCESS_RESPONSE_TYPE) {
            throw new Error('Unable to fetch member profile')
          } else {
            setMember(member.data)
          }
        }

        setUser(user)
      } catch (error) {
        reportError(error)
      } finally {
        setIsLoading(false)
      }
    }

    fetchData()
  }, [currentWorkspaceId])

  return { user, member, isLoading }
}
